import React from "react";

import {
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { format } from "date-fns";
import { ReaderApplicationData } from "./classes";

function DevicesTable (
  readerApplicationData: Array<ReaderApplicationData>,
  handleCopy: (serial: string) => void
) {
  return (
    <TableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableRow key="header-row">
            <TableCell>
              Serial
            </TableCell>
            <TableCell>
              Last Process List
            </TableCell>
            <TableCell size="small">
              Application Name
            </TableCell>
            <TableCell size="small">
              Application Version
            </TableCell>
            <TableCell size="small"/>
          </TableRow>
        </TableHead>
        <TableBody>
          {readerApplicationData &&
            // eslint-disable-next-line react/destructuring-assignment
            readerApplicationData.map(({serial, lastProcessList, appName, appVersion}) => (
              <TableRow key={serial + appName}>
                <TableCell>
                  {serial}
                </TableCell>
                <TableCell>
                  {lastProcessList
                    ? format(
                      new Date(lastProcessList),
                      "dd MMMM yyyy HH:mm"
                    )
                    : "-"}
                </TableCell>
                <TableCell size="small">
                  {appName}
                </TableCell>
                <TableCell size="small">
                  {appVersion}
                </TableCell>
                <TableCell size="small">
                  <IconButton
                    edge="end"
                    aria-label="copy"
                    onClick={() => handleCopy(serial)}
                  >
                    <ContentCopyIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DevicesTable;